const Visualizar = () => import('@/domains/servicos/views/Visualizar')
const Listar = () => import('@/domains/servicos/views/Listar')
const Editar = () => import('@/domains/servicos/views/Editar')
const Adicionar = () => import('@/domains/servicos/views/Adicionar')

const routes = [
    {
        name: 'listarServicosEmissor',
        path: '/emissor/servicos',
        alias: ['/emissor/servicos/index'],
        component: Listar
    },
    {
        name: 'visualizarServicoEmissor',        
        path: '/emissor/servicos/visualizar/:id',
        component: Visualizar
    },
    {
        name: 'adicionarServicoEmissor', 
        path: '/emissor/servicos/adicionar',
        component: Adicionar
    },
    {
        name: 'editarServicoEmissor',      
        path: '/emissor/servicos/editar/:id',
        component: Editar
    },
]

export default routes
